import { logosSlider, feedbackSlider } from "./sliders";
import initToggles from "./toggle";
import initSubmenuToggle from "./toggle-submenu";
import addAccordion from "./accordion";
import openProductGalleryModal from "./product-modal";

logosSlider();
feedbackSlider();
initToggles();
initSubmenuToggle();
addAccordion();
openProductGalleryModal();
